import MuiAlert from "@mui/material/Alert";
import { styled } from "@mui/material/styles";

const MuiAlertComponent = styled(MuiAlert)(() => ({
  marginBottom: 10,
}));

export default MuiAlertComponent;